import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AlertService } from '@nx-vigil/core/web/alert/data-access';
import { EMPTY, concatMap, map } from 'rxjs';
import { SnackBarComponent } from './snack-bar.component';

@Component({
  selector: 'core-alert',
  imports: [MatSnackBarModule],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  private readonly alertService = inject(AlertService);
  private readonly snackBar = inject(MatSnackBar);

  public constructor() {
    this.alertService.alert$
      .pipe(
        takeUntilDestroyed(),
        concatMap(alert => {
          const snackBarRef = this.snackBar.openFromComponent(
            SnackBarComponent,
            {
              horizontalPosition: 'end',
              verticalPosition: 'top',
              data: alert,
              duration: alert.duration,
            },
          );
          return snackBarRef.afterDismissed().pipe(map(() => EMPTY));
        }),
      )
      .subscribe();
  }
}
